module.exports = __webpack_public_path__ + "static/media/mobile-service-ios.411b2225.jpg";